module.exports = __webpack_public_path__ + "assets/Arrow-right-alt.51256aa2.svg";